import { Utilities } from 'src/app/core/helper/util';
import { SafeResourceUrl } from '@angular/platform-browser';
import { VideoSource } from 'src/app/core/data/schema/video-source';

export class Upload {

    mimeType: string;
    thumbPath: string | SafeResourceUrl;
    safeUrl: string | SafeResourceUrl;
    videoSources: VideoSource[] = [];
    isBase64 = false;
    isEmbedVideo = false;
    isImage = false;
    isBlob = false;
    isDoc = false;
    description: string;
    filename: string;
    isVideo = false;

    constructor(public path?: string) {
        if (path == null) {
            return;
        }

        if (path.startsWith('data')) {
            this.parseBase64(path);
        } else if (path.startsWith('blob')) {
            this.isBlob = true;
        } else {


            const imageTypes = ['jpeg', 'png', 'gif', 'bmp', 'jpg', 'webp', 'svg', 'ico'];
            const videoTypes = ['mp4', 'mpeg', 'avi', 'mkv'];
            const extension = path.split('.').pop().toLowerCase();

            if (imageTypes.indexOf(extension) > -1) {
                this.mimeType = `image/`;
            } else if (videoTypes.indexOf(extension) > -1) {
                this.mimeType = `video/`;
            } else {
                this.mimeType = `application/`;
            }

            this.mimeType += extension;
            this.safeUrl = path;

            this.testType();

            // if it's an mp4 video and it's from the API add an alt
            if (this.isVideo && this.mimeType === 'video/mp4' && this.path.includes('cdn.stonedapp')) {
                // Add the webm version
                const webm = this.path.replace('.mp4', '.webm');
                const altSource = new VideoSource({
                    filePath: webm,
                    safeUrl: webm,
                    mimeType: 'video/webm',
                    fileName: Utilities.generateUuidv4() + '.webm'
                });
                this.videoSources.push(altSource);
            }
        }

        // Set the thumbnail, would be good to have real ones
        this.thumbPath = path;
    }

    testType() {
        if (this.mimeType.includes('image')) {
            this.isImage = true;
        } else if (this.mimeType.includes('video')) {
            this.isVideo = true;
        } else if (this.mimeType.includes('application')) {
            this.isDoc = true;
        } else {
            this.isEmbedVideo = (this.isImage === false && this.isDoc === false && this.isVideo === false && this.isBlob === false);
        }
    }

    async getBase64() {
        return await Utilities.getBase64FromDataUrl(this.path);
    }

    async getBlob() {
        const blob = await fetch(this.path).then(r => r.blob());
        return new Blob([blob], { type: this.mimeType });
    }

    async toFormData(filename: string) {
        const blob = await this.getBlob();
        const formData = new FormData();
        formData.append('csvFile', blob, filename);
        return formData;
    }

    private parseBase64(base64: string) {
        this.safeUrl = base64;
        this.isBase64 = true;
    }

}
